import React, { useState } from 'react'
import { useTranslation } from "next-i18next";

const CircleCard = ({ percentage, title, description, isHovered, onMouseEnter, onMouseLeave, zIndex, className }) => {
    const { t } = useTranslation();
    return (
        <div
            className={`flex flex-col items-center justify-center relative ${className}`}
            style={{ zIndex }}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            <div className={`
                w-[260px] h-[260px] sm:w-[300px] sm:h-[300px] md:w-[340px] md:h-[340px] lg:w-[400px] lg:h-[400px] xl:w-[420px] xl:h-[420px]
                cursor-pointer rounded-full flex flex-col items-center justify-center bg-white/20 relative gap-[10px] lg:gap-[20px] overflow-hidden
                ${isHovered ? 'shadow-[inset_0_0_4px_0_rgba(255,255,255,1),_0_5px_15px_0_rgba(255,255,255,0.2)]' : ''}
                transition-shadow duration-700
            `}>
                <div className={`
                    w-[72px] h-[72px] md:w-20 md:h-20 lg:w-[100px] lg:h-[100px] xl:w-[120px] xl:h-[120px]
                    rounded-full flex items-center justify-center relative z-10 bg-white
                    transition-all duration-700 ease-in-out
                    ${isHovered ? '-translate-y-[150px] opacity-0' : 'translate-y-0 opacity-100'}
                `}>
                    <span className="text-[#FE5351] text-[20px] md:text-2xl lg:text-[32px] xl:text-[40px] font-bold">
                        {percentage}
                    </span>
                </div>
                <div className={`
                    text-white text-center leading-relaxed px-4 sm:px-5
                    transition-all duration-700 ease-in-out
                    ${isHovered ? 'opacity-0 h-0 overflow-hidden pointer-events-none' : 'opacity-100'}
                `}>
                    <span className='text-[16px] md:text-lg lg:text-[24px] xl:text-[32px] font-semibold'>
                        {title}
                    </span>
                </div>
                <div className={`
                    absolute inset-0 flex items-center justify-center px-6 sm:px-8 md:px-10 lg:px-12
                    transition-all duration-700 ease-in-out
                    ${isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-full pointer-events-none'}
                `}>
                    <p className="text-white text-[10px] sm:text-[12px] md:text-[14px] lg:text-[16px] font-normal text-center leading-relaxed max-w-full">
                        {description}
                    </p>
                </div>
            </div>
        </div>
    )
}

const SuccessFormula = () => {
    const [hoveredCircle, setHoveredCircle] = useState(null)
    const { t } = useTranslation();

    const circles = [
        {
            id: 1,
            percentage: '60%',
            title: t("methodology-page.hero-slide-1-bubble-1"),
            description: t("methodology-page.hero-slide-1-bubble-1-subtitle"),
            zIndex: 2,
            className: 'w-full md:w-auto'
        },
        {
            id: 2,
            percentage: '40%',
            title: t("methodology-page.hero-slide-2-bubble-1"),
            description: t("methodology-page.hero-slide-2-bubble-2-subtitle"),
            zIndex: 1,
            className: 'w-full md:w-auto ml-0 lg:-ml-12 -mt-[40px] lg:mt-0'
        }
    ]

    return (

        <div className="max-w-[90%] mx-auto bg-[#FE5351] rounded-3xl md:rounded-[64px] my-[80px] lg:my-[200px]">
            <div className='px-4 sm:px-6 md:px-8 lg:px-12 py-12 sm:py-16 md:py-20 lg:py-24 mx-auto flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12'>
                <div className='flex flex-col gap-5 sm:gap-6 md:gap-8 lg:gap-10 w-full lg:w-[40%]'>
                    <h2 className='text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-medium text-white leading-tight'>
                        {t("methodology-page.hero-slide-2-title")}
                    </h2>
                    <p className='text-sm sm:text-base md:text-lg lg:text-xl font-normal leading-relaxed text-white'>
                        {t("methodology-page.hero-slide-2-subtitle")}
                    </p>
                </div>
                <div className="flex flex-col lg:flex-row items-center justify-center relative w-full gap-4 lg:gap-0">
                    {circles.map((circle) => (
                        <CircleCard
                            key={circle.id}
                            percentage={circle.percentage}
                            title={circle.title}
                            description={circle.description}
                            isHovered={hoveredCircle === circle.id}
                            onMouseEnter={() => setHoveredCircle(circle.id)}
                            onMouseLeave={() => setHoveredCircle(null)}
                            zIndex={circle.zIndex}
                            className={circle.className}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}

export default SuccessFormula
